<template>
  <div
    class="menu-anchor-links pr0 col-sm-12 pl0 carousel-pr-12 lh16"
    v-if="isAnchorLinkVariant"
    :activeMenuIsProp="activeMenuIs"
  >
    <div>
      <div id="new-nav-anchor">
        <template v-for="(value, index) in HorizontalBannerData">
          <div
            :id="`${value.nodeName}_${index}`"
            v-if="isVisible(value, index)"
            :key="index"
          >
            <div
              class="flex-column flex-wrap cursor-pointer menu-anchor-link justify-content-between carousel__item"
              :style="{ width: 'max-content' }"
              @click.stop="
                goto(
                  index,
                  value.nodeId,
                  value.nodeName,
                  value.children.length || 0,
                )
              "
            >
              <span
                class="fs-12 color-grey-light"
                :class="{
                  'color-black': getStopHorizontalScroll
                    ? value.nodeName === getClickedCategoryAnchorLink
                    : getStopHorizontalScrollByFilterClick
                      ? value.nodeName === shouldScrollTo(value.nodeName)
                      : index === currentSlide,
                }"
                :style="{ margin: '13.5px 0' }"
                >{{ value.nodeName }}
              </span>
              <span
                :class="{
                  highlight: getStopHorizontalScroll
                    ? value.nodeName === getClickedCategoryAnchorLink
                    : getStopHorizontalScrollByFilterClick
                      ? value.nodeName === shouldScrollTo(value.nodeName)
                      : index === currentSlide,
                }"
              ></span>
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- <span
      v-if="Object.keys(getBottomBarData).length > 0 && clientPlatform != 'Web'"
      @click="triggerNewMenuModal()"
      class="menu-anchor-full-menu fs-14 flex-row justify-content-center"
    >
      <img
        :src="staticImgBaseUrl + '/images/global/hamburger.svg'"
        alt="hamburger"
        class="pt12 pl12"
      />
      <i aria-hidden="true" class="jfi-list-view"></i>
    </span> -->
  </div>
</template>

<script>
import { Carousel, Slide } from "vue3-carousel";
import { clientPlatform } from "../config/apiEndpoints";
import "vue3-carousel/dist/carousel.css";
import Utility from "../helpers/utility";
import { setEvents } from "../helpers/analyticsEvents";
import { keyMapsMutation, keyMapsGetter } from "../helpers/storeKeys";
// import userActivityTracking from "../helpers/UserActivityTracking";
import LocalStorageFunc from "../helpers/localStorageFunc";
import PageNames from "../config/pageNames";
import { staticImgBaseUrl } from "../config/apiEndpoints";
import {
  EVENT_PAGEVIEW_MENUPAGE,
  EVENT_CLICK_MENU_CATEGORY,
} from "../helpers/analyticsEvents";

export default {
  name: "HorizontalNavWithAnchorLinks",
  components: {
    Carousel,
    Slide,
  },
  props: ["dataResults", "moduleProps"],
  data() {
    return {
      currentSlide: 0,
      itemsToShow: 3.1,
      settings: {
        snapAlign: "center",
      },
      activeMenu: "",
      menuArray: [],
      clickedFromFilter: "",
      selectedMenuCategoryForce: {
        id: "",
        category: "",
      },
      lastCategoryWithOneProduct: false,
      isBottom: false,
      staticImgBaseUrl,
      HorizontalBannerData: [],
      clientPlatform,
      headerScrollTimer: null,
      lastHeaderScrollY: 0,
    };
  },
  mounted() {
    this.loadData = Utility.tryJsonParse(this.dataResults, []);
    this.HorizontalBannerData = this.loadData?.menuHierarchyData;
    this.$store.commit(
      keyMapsMutation.UPDATE_PRODUCT_CATEGORY,
      this.loadData?.menuHierarchyData,
    );
    this.$store.commit(
      keyMapsMutation.UPDATE_IMG_BASE_URL,
      this.loadData?.mediaBaseURL,
    );
    this.menuArray = this.getBottomBarData
      ? Object.keys(this.getBottomBarData)
      : [];
    //Amplitude impression event load
    // const eventObj = Utility.amplitudeEventObj(
    //   "impression",
    //   "full menu",
    //   "-1",
    //   {
    //     menuCategories: this.menuArray.map((item) => item?.toLowerCase()),
    //     subSection: "navigation bar",
    //   }
    // );
    // setEvents("amplitude", "Impression", eventObj);

    if (
      this.isAnchorLinkAndNonSeparateMenuVariant ||
      Utility.isSeparateMenuVariant()
    ) {
      window.addEventListener("scroll", () => {
        this.watchProductCounterString();
      });
    }
    window.addEventListener("scroll", this.handleStickyHeaderScroll);
    LocalStorageFunc.setPrevUrl(window.location.href);
  },
  destroyed() {
    if (
      this.isAnchorLinkAndNonSeparateMenuVariant ||
      Utility.isSeparateMenuVariant()
    ) {
      window.removeEventListener("scroll", this.watchProductCounterString);
    }
    window.removeEventListener("scroll", this.handleStickyHeaderScroll);
    clearTimeout(this.headerScrollTimer);
    document.body.classList.remove("menu-header-scrolling");
  },
  watch: {
    appliedFilters() {
      // Double nextTick: first tick lets VerticalProductsScrollMenu redirect the category
      // if it became empty; second tick ensures DOM has re-rendered with updated visibility
      // so offsetLeft reflects the actual post-filter layout.
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.scrollSelectedCategoryToCenter();
        });
      });
    },
    selectedMenuCategoryForce: {
      handler(newVal, oldVal) {
        let { id: categoryId, category: categoryName } = newVal;
        const bottomBarData = this.getBottomBarData; //menuData;
        if (categoryName === "" && categoryId === "") {
          return;
        }
        if (categoryName === "next" || categoryName === "pre") {
          const currentSelectedCategoryIndex = this.currentSlide;
          let selectedCategoryIndexToBe;
          if (categoryName === "next") {
            selectedCategoryIndexToBe = currentSelectedCategoryIndex + 1;
            if (selectedCategoryIndexToBe <= this.menuArray?.length - 1) {
              categoryName = this.menuArray[selectedCategoryIndexToBe];
              categoryId = bottomBarData[categoryName]?.categoryId;
            } else {
              return;
            }
          } else {
            selectedCategoryIndexToBe = currentSelectedCategoryIndex - 1;
            if (selectedCategoryIndexToBe >= 0) {
              categoryName = this.menuArray[selectedCategoryIndexToBe];
              categoryId = bottomBarData[categoryName]?.categoryId;
            } else {
              return;
            }
          }
        } else if (categoryId === undefined || Number(categoryId) == -1) {
          //default case
          categoryName = this.menuArray[0];
          categoryId = bottomBarData[categoryName]?.categoryId;
        }
        this.goto(
          this.menuArray.indexOf(categoryName),
          categoryId,
          categoryName,
          this.menuArray?.length || 0,
          false,
        );
      },
    },
    clickedFromFilter(newVal, oldVal) {
      if (newVal === true) {
        let scrollToIndex = 0; //first item

        if (
          scrollToIndex != undefined &&
          scrollToIndex !== -1 &&
          scrollToIndex === this.currentSlide &&
          this.getStopHorizontalScrollByFilterClick //causing isuse when veg pizza is on cart and non veg filter is selected --fix
        ) {
          this.$store.commit(
            keyMapsMutation.UPDATE_STOP_HORIZONTAL_SCROLL_ANCHOR_LINKS_FILTER_CLICK,
            false,
          );
        }
      }
    },
    activeMenu(newVal, oldVal) {
      if (newVal !== oldVal) {
        let MenuArray = this.HorizontalBannerData; //camelCase
        let scrollToIndex = MenuArray.findIndex((x) => x.nodeName === newVal);
        let selectedCategory = Utility.isSeparateMenuVariant()
          ? MenuArray[scrollToIndex]?.nodeName
          : this.getCategoryNameAndCountForBottomBar?.find((x) => x.count)
              ?.categoryName;

        if (
          scrollToIndex != undefined &&
          scrollToIndex !== -1 &&
          scrollToIndex !== this.currentSlide &&
          ((this.getStopHorizontalScroll &&
            newVal === this.getClickedCategoryAnchorLink) ||
            (this.getStopHorizontalScrollByFilterClick &&
              newVal === selectedCategory) ||
            (!this.getStopHorizontalScrollByFilterClick &&
              !this.getStopHorizontalScroll)) //! case for scrolling sync
        ) {
          let tempId = newVal + "_" + scrollToIndex;

          if (
            this.getClickedCategoryAnchorLink ===
              MenuArray[MenuArray.length - 1] &&
            this.lastCategoryWithOneProduct
          ) {
            return;
          }
          this.scrollingFunc(scrollToIndex, this.currentSlide, tempId);
          this.slideTo(scrollToIndex);

          if (this.getStopHorizontalScrollByFilterClick) {
            this.$store.commit(
              keyMapsMutation.UPDATE_STOP_HORIZONTAL_SCROLL_ANCHOR_LINKS_FILTER_CLICK,
              false,
            );
          }

          if (this.getStopHorizontalScroll) {
            this.$store.commit(
              keyMapsMutation.UPDATE_STOP_HORIZONTAL_SCROLL_ANCHOR_LINKS,
              false,
            );
            // this.$store.commit(
            //   keyMapsMutation.UPDATE_CLICKED_CATEGORY_ANCHOR_LINK,
            //   ""
            // );
          }
        }
        //case where anchor link is on 1st category and filter is selected
        if (
          scrollToIndex === this.currentSlide &&
          this.getStopHorizontalScrollByFilterClick &&
          newVal ===
            this.getCategoryNameAndCountForBottomBar?.find((x) => x.count)
              ?.categoryName
        ) {
          this.$store.commit(
            keyMapsMutation.UPDATE_STOP_HORIZONTAL_SCROLL_ANCHOR_LINKS_FILTER_CLICK,
            false,
          );
        }

        if (
          scrollToIndex === MenuArray.length - 2 &&
          this.getStopHorizontalScroll &&
          this.getClickedCategoryAnchorLink ===
            MenuArray[MenuArray.length - 1] &&
          this.lastCategoryWithOneProduct === true &&
          (this.isAnchorLinkAndNonSeparateMenuVariant ||
            Utility.isSeparateMenuVariant())
        ) {
          let tempId =
            this.getClickedCategoryAnchorLink + "_" + (scrollToIndex + 1); //+1 for last category because intersection observer only reaches to -2 but we need last

          this.scrollingFunc(scrollToIndex + 1, this.currentSlide, tempId);
          this.slideTo(scrollToIndex + 1);

          this.$store.commit(
            keyMapsMutation.SET_PRODUCT_COUNTER_STRING,
            this.getClickedCategoryAnchorLink,
          );

          if (this.isBottom) {
            this.$store.commit(
              keyMapsMutation.UPDATE_STOP_HORIZONTAL_SCROLL_ANCHOR_LINKS,
              false,
            );
          }
        }
        EVENT_PAGEVIEW_MENUPAGE({ category: newVal });
        EVENT_CLICK_MENU_CATEGORY({
          userAction: "menu category view",
          sectionPosition: 1,
          category: newVal?.toLowerCase() || "",
        });
        this.$store.commit(
          keyMapsMutation.UPDATE_CLICKED_CATEGORY_ANCHOR_LINK,
          newVal,
        );
      }
    },
  },
  methods: {
    processResultDataForStore(data) {
      this.$store.commit(keyMapsMutation.UPDATE_PRODUCTS_IN_STORE, data);
      this.$store.commit(keyMapsMutation.LOAD_CART_FROM_STORAGE_SERVICE, {});
    },
    scrollSelectedCategoryToCenter() {
      const clickedCategory = this.$store.state.Menu.clickedCategoryAnchorLink;
      if (!clickedCategory) return;

      const menuIndex = this.HorizontalBannerData.findIndex(
        (x) => x.nodeName === clickedCategory,
      );
      if (menuIndex === -1) return;

      const id = `${clickedCategory}_${menuIndex}`;
      const containerRef = document.getElementById("new-nav-anchor");
      const targetEle = document.getElementById(id);
      if (!containerRef || !targetEle) return;

      const scrollLeft =
        targetEle.offsetLeft -
        containerRef.offsetWidth / 2 +
        targetEle.offsetWidth / 2;

      containerRef.scrollTo({
        left: Math.max(0, scrollLeft),
        behavior: "smooth",
      });
    },
    checkSepMenuPage() {
      let linkRewrite = Utility.getCurrentStoreFolder(); // /menu/
      linkRewrite = "pwa" + linkRewrite;
      if (linkRewrite === "pwa/menu/") {
        return true;
      }
      return false;
    },
    handleStickyHeaderScroll() {
      const currentScrollY = window.scrollY || window.pageYOffset;
      const scrollingDown = currentScrollY > this.lastHeaderScrollY;
      clearTimeout(this.headerScrollTimer);
      if (scrollingDown && currentScrollY > 0) {
        document.body.classList.add("menu-header-scrolling");
        this.headerScrollTimer = setTimeout(() => {
          document.body.classList.remove("menu-header-scrolling");
        }, 200);
      } else {
        document.body.classList.remove("menu-header-scrolling");
      }
      this.lastHeaderScrollY = currentScrollY;
    },
    watchProductCounterString() {
      // if (
      //   window.pageYOffset < 50 &&
      //   !this.productCounterString?.startsWith("undefined") &&
      //   !Utility.isSeparateMenuVariant()
      // ) {
      //   this.$store.commit(
      //     keyMapsMutation.SET_PRODUCT_COUNTER_STRING,
      //     "undefined"
      //   );
      // }

      if (
        this.lastCategoryWithOneProduct &&
        (Utility.isSeparateMenuVariant() ||
          this.isAnchorLinkAndNonSeparateMenuVariant)
      ) {
        let documentHeight = document.body.scrollHeight;
        let currentScroll = window.scrollY + window.innerHeight;
        let modifier = 80;
        if (currentScroll + modifier > documentHeight) {
          //console.log('You are at the bottom!')
          this.$store.commit(
            keyMapsMutation.SET_PRODUCT_COUNTER_STRING,
            MenuArray[MenuArray.length - 1],
          );
          if (!this.isBottom) {
            this.isBottom = true;
            if (this.getStopHorizontalScroll) {
              this.$store.commit(
                keyMapsMutation.UPDATE_STOP_HORIZONTAL_SCROLL_ANCHOR_LINKS,
                false,
              );
              // this.$store.commit(
              //   keyMapsMutation.UPDATE_CLICKED_CATEGORY_ANCHOR_LINK,
              //   ""
              // );
            }
          }
        } else {
          let _ = localStorage.getItem("stopProductCounterStorage");
          if (_ !== undefined && _ !== null && _ !== "") {
            localStorage.setItem("stopProductCounterStorage", "");
          }
          //console.log("you r not------ at bottom");
          if (this.isBottom) {
            this.isBottom = false;
          }
        }
      }
    },
    triggerNewMenuModal() {
      // let menuArray = [];
      // menuArray = this.menuArray
      //   .filter((item) => {
      //     if (
      //       this.getBottomBarData[item]?.data &&
      //       Object.keys(this.getBottomBarData[item]?.data).length
      //     )
      //       return item;
      //   })
      //   .map((item) => item.toLowerCase());

      //Amplitude click event load
      // this.eventFunction(true, {
      //   positionWithinSection: "",
      //   sectionName: "navigation bar",
      //   category: "full menu",
      // });

      document.body.classList.add("body-stop-scroll-mobile");
      this.$store.commit(keyMapsMutation.UPDATE_NEW_MENU_MODAL_FLAG, true);
      this.$store.commit(
        keyMapsMutation.UPDATE_MENU_MODAL_FLAG_OPENED_FROM,
        "bottom menu",
      );

      //Amplitude impression event load
      // this.eventFunction(false, {
      //   sectionName: "full menu",
      //   subSection: "navigation bar",
      //   menuCategories: menuArray,
      //   menuCount: menuArray.length,
      // });
      // userActivityTracking.menuOpen(0);
    },
    eventFunction(isClicked = false, preEventObj = {}) {
      let eventType = isClicked ? "Click" : "Impression";
      let userAction = isClicked ? "click" : "impression";
      const eventObj = Utility.amplitudeEventObj(
        userAction,
        preEventObj["sectionName"] ? preEventObj["sectionName"] : "bottom menu",
        "-1",
        preEventObj,
      );
      setEvents("amplitude", eventType, eventObj);
    },
    goto(index, itmId, categoryName, count, flag = true) {
      //Amplitude click event load
      // this.eventFunction(true, {
      //   positionWithinSection: this.menuArray.indexOf(categoryName) + 1,
      //   sectionPosition: "",
      //   category: categoryName?.toLowerCase() || "",
      //   sectionName: "navigation bar",
      // });

      // if (!count) return;

      if (flag) {
        EVENT_CLICK_MENU_CATEGORY({
          userAction: "menu category click",
          sectionPosition: index | (0 + 1),
          category: categoryName?.toLowerCase() || "",
        });
      }

      this.$store.commit(keyMapsMutation.TRIGGER_FILTER_REF, {});
      // userActivityTracking.menuSelect(0, categoryName);
      if (itmId) {
        setTimeout(() => {
          this.$store.commit(
            keyMapsMutation.SET_PRODUCT_COUNTER_STRING,
            categoryName,
          );
          if (Utility.isSeparateMenuVariant() && flag) {
            this.$store.commit(
              keyMapsMutation.UPDATE_STOP_HORIZONTAL_SCROLL_ANCHOR_LINKS,
              true,
            );
            this.$store.commit(
              keyMapsMutation.UPDATE_CLICKED_CATEGORY_ANCHOR_LINK,
              categoryName,
            );
          }
        }, 0);
        setTimeout(() => {
          let scrollTopMargin = window.screen.width <= 321 ? 70 : 102;
          if (
            LocalStorageFunc.getSessionStorageKey("previousLinkRewrite") ===
            PageNames.HOME_PAGE
          ) {
            scrollTopMargin = 160;
          }

          if (!Utility.isSeparateMenuVariant()) {
            this.$store.commit(
              keyMapsMutation.UPDATE_STOP_HORIZONTAL_SCROLL_ANCHOR_LINKS,
              true,
            );
            this.$store.commit(
              keyMapsMutation.UPDATE_CLICKED_CATEGORY_ANCHOR_LINK,
              categoryName,
            );
          }
          Utility.scrollUptoTo("element_catg_" + itmId, scrollTopMargin);
        }, 0);

        if (
          this.lastCategoryWithOneProduct &&
          this.menuArray[this.menuArray.length - 1] === categoryName &&
          (this.isAnchorLinkAndNonSeparateMenuVariant ||
            Utility.isSeparateMenuVariant())
        ) {
          localStorage.setItem("stopProductCounterStorage", categoryName);
        }
      }
    },
    slideTo(val) {
      this.currentSlide = val;
    },
    scrollingFunc(index, current, id) {
      let diff = index - current;
      if (diff !== 0) {
        let componentRef = document.getElementById("new-nav-anchor"); //cureent scrollleft
        let targetEle = document.getElementById(id);

        let futureScrollLeft = targetEle?.offsetLeft; //scroll to where
        componentRef.scrollLeft = futureScrollLeft - 50;
      }
    },
    shouldScrollTo(propertyName) {
      if (Utility.isSeparateMenuVariant()) {
        const filter =
          this.$store.state.ProductItems.orderFiltersData?.appliedFilters[0] ||
          {};
        if (Object.keys(filter).length > 0) {
          return filter.type === "NONVEG" ? "Non-Veg Pizza" : "Veg Pizza";
        }
      }
      return this.menuArray[0];
    },
    isVisible(value, index) {
      return (
        value.visible &&
        value.children.length &&
        !value?.metadataMap["is_independent_category"]?.values.includes(
          "true",
        ) &&
        this.getCategoryNameAndCountForBottomBar.find(
          (x) => x.nodeId === value.nodeId,
        )?.count != 0
      );
    },
  },
  computed: {
    getBottomBarData() {
      //return this.$store.state.ProductItems.productItems;
      return this.$store.state.ProductItems.productCategory;
      // let finalObj = {};
      // for (const key in dataObj) {
      //   if (
      //     Object.keys(dataObj[key]?.data).length &&
      //     dataObj[key].categoryId !== 9999
      //   ) {
      //     finalObj[key] = dataObj[key];
      //   }
      // }
      // this.menuArray = Object.keys(finalObj);
      // if (
      //   this.menuArray.length &&
      //   Object.keys(finalObj[this.menuArray[this.menuArray.length - 1]]?.data)
      //     .length === 1 &&
      //   (this.isAnchorLinkAndNonSeparateMenuVariant ||
      //     Utility.isSeparateMenuVariant())
      // ) {
      //   this.lastCategoryWithOneProduct = true;
      // } else {
      //   this.lastCategoryWithOneProduct = false;
      // }

      // return finalObj;
    },
    isAnchorLinkVariant() {
      return true;
    },
    activeMenuIs() {
      let _ = this.$store.state.ProductItems.productCounterString;
      let menuLinkName = _ ? _.split("|")[0].replace("Showing", "").trim() : ""; //Non-Veg Pizza
      if (Utility.isSeparateMenuVariant()) {
        menuLinkName = menuLinkName.split("(")[0]?.trim();
      }
      this.activeMenu = menuLinkName;
    },
    appliedFilters() {
      return this.$store.getters[keyMapsGetter.GET_APPLIED_FILTERS];
    },
    getStopHorizontalScroll() {
      return this.$store.state.Menu.stopHorizontalScrollAnchorLinks;
    },
    getClickedCategoryAnchorLink() {
      let _ = this.$store.state.Menu.clickedCategoryAnchorLink;
      return _;
    },
    getStopHorizontalScrollByFilterClick() {
      let _ = this.$store.state.Menu.stopHorizontalScrollAnchorLinksFilterClick;
      if (_ !== undefined) {
        this.clickedFromFilter = _;
      }
      return _;
    },
    productCounterString() {
      return this.$store.state.ProductItems.productCounterString;
    },
    isAnchorLinkAndNonSeparateMenuVariant() {
      return true;
    },
    getSelectedMenuCategory() {
      let selectedCategory =
        this.$store.getters[keyMapsGetter.GET_SELECTED_MENU_CATEGORY];
      this.selectedMenuCategoryForce = selectedCategory;
      return;
    },
    getCategoryNameAndCountForBottomBar() {
      let productItems =
        this.$store.getters[
          keyMapsGetter.GET_CATEGORY_NAME_AND_COUNT_FOR_BOTTOM_BAR
        ];
      return productItems;
    },
  },
};
</script>

<style lang="scss" scoped></style>
